import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/Basics/MDButton";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { PUBLIC, AccessLabel } from "contants";
import { Chip, Icon } from "@mui/material";
import { t } from "i18next";
import MDBox from "components/Basics/MDBox";
import { useDispatch } from "react-redux";
import SourceActions from "redux-react/actions/sourceActions";

const ChangeAccessDialog = ({ open, onClose, listIds, reloadAssets }) => {
	const dispatch = useDispatch();

	const getAcessColor = value => {
		if (value === "public") return "success";
		if (value === "private") return "warning";
		return "warning";
	};

	const getIcon = value => {
		if (value === PUBLIC) {
			return <Icon fontSize="small">lock_open</Icon>;
		} else {
			return <Icon fontSize="small">lock_outline</Icon>;
		}
	};

	const handleChange = value => {
		dispatch(
			SourceActions.updateAssets(
				listIds,
				{
					access: value
				},
				() => {
					reloadAssets();
					onClose();
				}
			)
		);
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="asset-selection-dialog-title"
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle
				id="asset-selection-dialog-title"
				sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
			>
				{t("ASSETS.ACTIONS.changeAccessTitle")}
				<IconButton aria-label="close" onClick={onClose} sx={{ color: "#666" }}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers>
				{AccessLabel.map(option => (
					<MDBox m={1}>
						<Chip
							label={t(option.label)}
							size="large"
							color={getAcessColor(option.value)}
							variant="outlined"
							onClick={() => handleChange(option.value)}
							icon={getIcon([option.value])}
							sx={{
								width: "30%"
							}}
						/>
					</MDBox>
				))}
			</DialogContent>

			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={onClose}>
					{t("SETTINGS.cancel")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

export default ChangeAccessDialog;
